import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import {
  SEARCH_SORT_SCORE_ALPHA,
  SEARCH_SORT_ALPHA_ASC,
  SEARCH_SORT_ALPHA_DESC,
} from '../../modules/App/search.tsx';

const propTypes = {
  count: PropTypes.number,
  searchTerm: PropTypes.string,
  handleChange: PropTypes.func,
};

export default function SearchHeader(
  props: InferProps<typeof propTypes>,
): JSX.Element {
  const { count, searchTerm, handleChange } = props;

  return (
    <>
      <div className="spacer"></div>
      <div className="search-header">
        <Row className="search-header__term">
          {searchTerm
          ? <Col>{`Search results for '${searchTerm}'`}</Col>
          : <Col>Enter a search term to refine results</Col>
          }
        </Row>
        <Row className="search-header__centred-row">
          <Col xs={12} md={6} className="search-header__count">
            {!searchTerm && <>Showing all </>}
            <strong>{count}</strong> item(s)
            {searchTerm && <> matching your search terms.</>}
          </Col>
          <Col xs={12} md={6}>
            <div className="search-header__sort">
              Sort by:
              <select onChange={handleChange}>
                <option value={SEARCH_SORT_SCORE_ALPHA}>Relevance</option>
                <option value={SEARCH_SORT_ALPHA_ASC}>Alphabetical A-Z</option>
                <option value={SEARCH_SORT_ALPHA_DESC}>Alphabetical Z-A</option>
              </select>
            </div>
          </Col>
        </Row>
        <div className="spacer spacer--end"></div>
      </div>
    </>
  );
}
